import { OpenFeature, InMemoryProvider } from '@openfeature/web-sdk';
import { FLAG_DEFAULTS } from './feature-flags';

export { FeatureFlags, FLAG_DEFAULTS } from './feature-flags';
export type { FeatureFlagKey, FlagValueMap } from './feature-flags';

export function initOpenFeature() {
  OpenFeature.setProvider(
    new InMemoryProvider(
      Object.fromEntries(
        Object.entries(FLAG_DEFAULTS).map(([key, defaultValue]) => [
          key,
          {
            disabled: false,
            variants: { on: true, off: false },
            defaultVariant: defaultValue ? 'on' : 'off',
          },
        ]),
      ),
    ),
  );
}

export function setFeatureFlagContext(user: {
  sub: string;
  email: string;
  role?: string;
}) {
  OpenFeature.setContext({
    targetingKey: user.sub,
    email: user.email,
    role: user.role ?? 'viewer',
  });
}
